// Copyright Epic Games, Inc. All Rights Reserved.

import { Selector } from "react-redux";
import { IAppState } from "../index";
import { sharedFeatureStoreKey } from "./reducer";

export const selectMainServiceAccessToken: Selector<IAppState, string> = (
  state
): string => state[sharedFeatureStoreKey].mainServiceAccessToken;
